export default "https://cdn-static.gokick.com/assets/8bc125c24491fd75c87852671f08945500f37a20/images/tangerine-flavor.1fe86552bc4a40407da21340599dcac8.png";